export default Object.freeze({
  home    : '/',
  board   : '/board/:id',
  about   : '/about',
  help    : '/help',
  cookies : '/cookies',
});
